export const fieldDisplayNames: { [key: string]: string } = {
  tourName: 'Nazwa wyjazdu',
  destinationCity: 'Miejscowość',
  destinationCountry: 'Kraj',
  participantLimit: 'Limit uczestników',
  startDate: 'Data rozpoczęcia',
  endDate: 'Data zakończenia',
  registrationStartDate: 'Data rozpoczęcia rejestracji',
  registrationEndDate: 'Data zakończenia rejestracji',
  tourDates: 'Daty wyjazdu',
  tourDestination: 'Lokalizacja',
  registrationDates: 'Daty rejestracji',
  prices: 'Cena bazowa',
  status: 'Status',
  sendStatus: 'Status wysyłki',
  availability: 'Zapisani',
  tour: 'Wyjazd',
  tourId: 'ID wyjazdu',

  booking: 'Rezerwacja',
  bookingStatus: 'Status rezerwacji',
  participant: 'Uczestnik',
  waitlistClient: 'Zapisujący',
  appUser: 'Użytkownik',
  id: 'ID',
  firstName: 'Imię',
  lastName: 'Nazwisko',
  birthDate: 'Data urodzenia',
  age: 'Wiek',
  registrationDate: 'Data rejestracji',

  createdAt: 'Data utworzenia',
  client: 'Zapisujący',
  participantCount: 'Liczba uczestników',
  paymentStatus: 'Status płatności',
  dueDate: 'Termin płatności',
  totalAmount: 'Kwota',
  amountForParticipant: 'Kwota za uczestnika',
  transactionDate: 'Data transakcji',
  amount: 'Kwota',
  description: 'Opis',
  counterpartyName: 'Nazwa kontrahenta',
  direction: 'Typ',
  extractedPaymentId: 'ID płatności',
  installmentDetails: 'Szczegóły raty',
  paymentMethod: 'Metoda płatności',
  costCategoryName: 'Kategoria kosztu',

  channel: 'Kanał',
  type: 'Typ',
  triggerType: 'Wyzwalacz',
  scheduledAt: 'Zaplanowano na',
  sentAt: 'Wysłano',
  recipientType: 'Typ odbiorcy',
  recipientName: 'Nazwa odbiorcy',
  sentToEmail: 'Adres e-mail',
  renderedSubject: 'Temat',
  date: 'Data',

  optionName: 'Nazwa opcji',
  variantName: 'Nazwa wariantu',
  optionAvailability: 'Dostępność opcji',
  variantAvailability: 'Dostępność wariantu',

  name: 'Nazwa',
  position: 'Pozycja',
  email: 'E-mail',
  phoneNumber: 'Numer telefonu',
  registrationMode: 'Rejstracja',
  published: 'Widoczny',
  // Ta sama kolumna jest w tabelach opcji, zgód i ubezpieczeń — stąd nazwa bez rodzaju.
  archived: 'W archiwum',

  registrationDetails: 'Zapisy',
  displayName: 'Nazwa',
  required: 'Wymagane',
  consentCode: 'Numer umowy',

  consentTemplateVersion: 'Numer wersji',
  acceptedAt: 'Data akceptacji',
  consentStatus: 'Status zgody',
  sentTo: 'Wysłano na',
  messageTemplateType: 'Typ szablonu',

  discount: 'Rabat',
  promoCode: 'Kod promocyjny',
  usages: 'Użycia',
  active: 'Aktywna',

  linkOrFile: 'Szczegóły',
  totalValue: 'Kwota',
  unallocatedValue: 'Nieprzypisane',

  tags: 'Tagi',
  selectedTransportVariant: 'Transport',

  role: 'Rola',
  expiresAt: 'Data wygaśnięcia',

  insurance: 'Ubezpieczenie',
  insurances: 'Ubezpieczenia',
  insuredParticipantCount: 'Liczba ubezpieczonych',
  selectionDate: 'Data wyboru',
};
